import { useState } from 'react'
import { Info, Briefcase, History } from 'lucide-react'
import { AnimatePresence } from 'framer-motion'
import { CloserLeadDetailsInfoTab } from '@/components/CloserLeads/Modals/CloserLeadDetailsInfoTab'
import { CloserLeadDetailsHistoryTab } from '@/components/CloserLeads/Modals/CloserLeadDetailsHistoryTab'
import { CloserLeadDetailsDealsTab } from '@/components/CloserLeads/Modals/CloserLeadDetailsDealsTab'
import type { CloserLeadDetailsProps } from '@/components/CloserLeads/Modals/closerLeadDetailsTypes'

export function CloserLeadDetails({
  lead,
  onConvertToDeal,
  onDiscardLead,
  onRegisterContact,
  showRegForm: externalShowRegForm,
  setShowRegForm: externalSetShowRegForm,
  showDiscardForm: externalShowDiscardForm,
  setShowDiscardForm: externalSetShowDiscardForm,
  regCanal: externalRegCanal,
  setRegCanal: externalSetRegCanal,
  regResultado: externalRegResultado,
  setRegResultado: externalSetRegResultado,
  regObs: externalRegObs,
  setRegObs: externalSetRegObs,
  onRegisterSubmit,
  newPendingText: externalNewPendingText,
  setNewPendingText: externalSetNewPendingText,
  onAddPending,
  onTogglePending,
  onRemovePending,
}: CloserLeadDetailsProps) {
  const [mainTab, setMainTab] = useState<'info' | 'history' | 'deals'>('info')

  const [intShowRegForm, setIntShowRegForm] = useState(false)
  const [intRegCanal, setIntRegCanal] = useState('Telefone')
  const [intRegResultado, setIntRegResultado] = useState('')
  const [intRegObs, setIntRegObs] = useState('')
  const [intNewPendingText, setIntNewPendingText] = useState('')
  const [intShowDiscardForm, setIntShowDiscardForm] = useState(false)

  const showRegForm = externalShowRegForm ?? intShowRegForm
  const setShowRegForm = externalSetShowRegForm ?? setIntShowRegForm
  const showDiscardForm = externalShowDiscardForm ?? intShowDiscardForm
  const setShowDiscardForm = externalSetShowDiscardForm ?? setIntShowDiscardForm
  const regCanal = externalRegCanal ?? intRegCanal
  const setRegCanal = externalSetRegCanal ?? setIntRegCanal
  const regResultado = externalRegResultado ?? intRegResultado
  const setRegResultado = externalSetRegResultado ?? setIntRegResultado
  const regObs = externalRegObs ?? intRegObs
  const setRegObs = externalSetRegObs ?? setIntRegObs
  const newPendingText = externalNewPendingText ?? intNewPendingText
  const setNewPendingText = externalSetNewPendingText ?? setIntNewPendingText

  const handleAddPendingClick = () => {
    if (!newPendingText.trim()) return
    if (onAddPending) {
      onAddPending()
    } else if (onRegisterContact) {
      onRegisterContact(lead.id, { canal: 'TAREFA', resultado: 'Pendência', obs: newPendingText })
      setNewPendingText('')
    }
  }

  const mainTabs = [
    { key: 'info' as const, label: 'Info', icon: <Info size={12} /> },
    { key: 'history' as const, label: 'Histórico', icon: <History size={12} /> },
    { key: 'deals' as const, label: 'Deals', icon: <Briefcase size={12} /> },
  ]

  const infoTabProps = {
    lead,
    showRegForm,
    setShowRegForm,
    showDiscardForm,
    setShowDiscardForm,
    regCanal,
    setRegCanal,
    regResultado,
    setRegResultado,
    regObs,
    setRegObs,
    onRegisterSubmit,
    onConvertToDeal,
    onDiscardLead,
  }

  return (
    <div className='flex flex-col gap-4 h-full'>
      <div className='p-1.5 rounded-xl bg-white/[0.02] border border-white/[0.06] flex gap-1'>
        {mainTabs.map((tab) => (
          <button
            key={tab.key}
            className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-lg text-[10px] font-bold uppercase tracking-wider transition-all ${
              mainTab === tab.key ? 'bg-accent text-white shadow-lg' : 'text-text-muted hover:text-text-primary'
            }`}
            onClick={() => setMainTab(tab.key)}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      <AnimatePresence mode='wait'>
        {mainTab === 'info' && <CloserLeadDetailsInfoTab {...infoTabProps} />}
        {mainTab === 'history' && (
          <CloserLeadDetailsHistoryTab
            lead={lead}
            newPendingText={newPendingText}
            setNewPendingText={setNewPendingText}
            onAddPending={handleAddPendingClick}
            onTogglePending={onTogglePending}
            onRemovePending={onRemovePending}
          />
        )}
        {mainTab === 'deals' && (
          <CloserLeadDetailsDealsTab lead={lead} onConvertToDeal={onConvertToDeal} />
        )}
      </AnimatePresence>
    </div>
  )
}

export default CloserLeadDetails
